import { IPreorderStandard } from 'my-poppies-b2b-types';

import { timestampMockHelpers } from '@/utils/timestampMockHelpers';

export const dummyDataPreorders: IPreorderStandard[] = [
  {
    userRole: 'EVA',
    id: 'first-standard-preorder',
    status: 'PREORDER',
    type: 'STANDARD',
    createdBy: 'EVA',
    createdAt: timestampMockHelpers.now,
    updatedBy: 'EVA',
    updatedAt: timestampMockHelpers.tenMinutesLater,
    positions: [
      { positionId: 'kleine-kapseln-40g', amount: 123 },
      { positionId: 'große-kapseln-120g', amount: 14 },
    ],
  },
  {
    userRole: 'EVA',
    id: 'second-standard-order',
    status: 'PREORDER',
    type: 'EXPRESS',
    createdBy: 'EVA',
    createdAt: timestampMockHelpers.now,
    updatedBy: 'EVA',
    updatedAt: timestampMockHelpers.tenMinutesLater,
    positions: [
      { positionId: 'kleine-kapseln-40g', amount: 123 },
      { positionId: 'große-kapseln-120g', amount: 14 },
    ],
  },
];
